import script from "./EventPriceCard.vue?vue&type=script&setup=true&lang=js"
export * from "./EventPriceCard.vue?vue&type=script&setup=true&lang=js"

const cssModules = {}
import style0 from "./EventPriceCard.vue?vue&type=style&index=0&id=a109d918&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules]])

export default __exports__